import { createAction } from "@reduxjs/toolkit";

export const resetSiteSpecificData = createAction("reset/clearResults");
export const siteSelectionChanged = createAction<{ siteId: string }>("site/selectionChanged");
export const applicationSessionChanged = createAction<{ identityKey: string | null }>(
  "application/sessionChanged"
);
